import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import {FinanceRoutingModule} from './finance-routing.module';
import {AuthenticationModule} from '../../authentication/authentication.module';
import { FileUploadModule } from "ng2-file-upload";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { ListProposalsComponent } from './list-proposals/list-proposals.component';
import { ListBoqsComponent } from './list-boqs/list-boqs.component';
import { CollapsibleModule } from 'angular2-collapsible';

@NgModule({
  imports: [
    CommonModule,
    FinanceRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    FileUploadModule,
    AuthenticationModule,
    CollapsibleModule

  ],
  declarations: [DashboardComponent, ListProposalsComponent, ListBoqsComponent]
})
export class FinanceModule { }



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/finance/finance.module.ts